import { QueryParams } from "@/models/query-params.model";
import api from "@/services/api-config/rxjs-config";
import { Observable } from "rxjs";

export class ClassesRest {
  getAllClasses(params: QueryParams): Observable<any> {
    const url: string = `/classroom`;
    return api.get(url, params);
  }

  getClassById(classId: string): Observable<any> {
    const url: string = `/classroom/${classId}`;
    return api.get(url, {});
  }

  addClass(data: any): Observable<any> {
    const url: string = `/classroom`;
    return api.post(url, data);
  }

  updateClass(classId: string, data: any): Observable<any> {
    const url: string = `/classroom/${classId}`;
    return api.put(url, data);
  }

  updateClassStatus(classId: string, data: any): Observable<any> {
    const url: string = `/classroom/${classId}/status`;
    return api.put(url, data);
  }

  importUsersByClassroom(classId: string, data: any): Observable<any> {
    const url: string = `/classroom/import/${classId}`;
    return api.post(url, data);
  }
}
